import React, {Component} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPaperclip, faArrowCircleRight} from '@fortawesome/free-solid-svg-icons'
import './input_chat.css'

export default class InputChat extends Component{

    render(){
        return(

                <form>
                    <div className='box-input'>
                        <input type='text' className='input-mensagem'/>
                        <FontAwesomeIcon icon={faPaperclip} color='white' size='lg' style={{marginLeft:'2%'}}/>
                        <button onClick={this.sendMessage} style={{border:'none', backgroundColor:'#F87C4C', cursor:'pointer'}}>
                            <FontAwesomeIcon icon={faArrowCircleRight} color='white' size='lg' style={{marginLeft:'10%'}}/>
                        </button>
                    </div>
                </form>

        )
    }
}
export class InputChatVideo extends Component{
    render(){
        return(
            <form>
                <div className='box-input-video'>
                    <input type='text' className='input-mensagem-video'/>
                </div>
            </form>
        )
    }
}